export class Translations {
    public static SHIPPING_RESTRICTION_ERROR = 'Below product(s) not available for delivery in {{stateName}}. Please remove this item from your cart before proceeding.';
    public static SHIPPING_RESTRICTED_PRODUCT_ERROR = 'Warning-This item cannot be shipped to your default shipping address.';
    static POP_UP_MESSAGE = 'common.Please enable showing pop-ups in the Browser';
    public static GUEST_SIGNUP_INPROGRESS =  'Previous Order is in Progress. Please try after some time';
    public static ENROLLMENT_INPROGRESS =  'Your Enrolment request is in Progress. Please wait for the confirmation';
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/translations.constants.ts